import axios from 'axios';

export const $http: any = axios.create({
  headers: {'Access-Control-Allow-Origin': '*'},
   //baseURL: (process.env.NODE_ENV == 'production') ? 'http://sepmsvdi01:44332/api' : 'http://localhost:44332/api'
   baseURL: (process.env.NODE_ENV == 'production') ? process.env.VUE_APP_DIAP_API : process.env.VUE_APP_DIAP_API
  //  baseURL: (process.env.NODE_ENV == 'production') ? 'https://diapeval01-ghgcdnekddh2hnhd.eastus-01.azurewebsites.net/api' : 'https://diapeval01-ghgcdnekddh2hnhd.eastus-01.azurewebsites.net/api'
  // baseURL: (process.env.NODE_ENV == 'production') ? 'http://diap.svr.cyphercrescent.com:44333/api' : 'http://diap.svr.cyphercrescent.com:44333/api'
  // baseURL: (process.env.NODE_ENV == 'production') ? 'https://diap-be.azurewebsites.net/api' : 'https://diap-be.azurewebsites.net/api'
})

// 'http://192.168.0.3:3000/'
export const HTTP: any = axios.create({
  headers: {'Access-Control-Allow-Origin': '*'},
  //baseURL: (process.env.NODE_ENV === 'production')? 'http://sepmsvdi01:44332/api' : 'http://localhost:44332/api'
  baseURL: (process.env.NODE_ENV == 'production') ? process.env.VUE_APP_DIAP_API : process.env.VUE_APP_DIAP_API
  // baseURL: (process.env.NODE_ENV == 'production') ? 'https://diapeval01-ghgcdnekddh2hnhd.eastus-01.azurewebsites.net/api' : 'https://diapeval01-ghgcdnekddh2hnhd.eastus-01.azurewebsites.net/api'
  // baseURL: (process.env.NODE_ENV == 'production') ? 'http://diap.svr.cyphercrescent.com:44333/api' : 'http://diap.svr.cyphercrescent.com:44333/api'
  // baseURL: (process.env.NODE_ENV == 'production') ? 'https://diap-be.azurewebsites.net/api' : 'https://diap-be.azurewebsites.net/api'
});                 

// https://192.168.0.3:44322/



